import { NgModule, InjectionToken } from '@angular/core';
//import { isPlatformBrowser } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  BrowserModule,
  BrowserTransferStateModule,
  TransferState,
  makeStateKey,
} from '@angular/platform-browser';

// Apollo
import {ApolloModule, APOLLO_OPTIONS} from 'apollo-angular';
import {HttpLink} from 'apollo-angular/http';
import {InMemoryCache} from '@apollo/client/core';

import { environment } from '../../../../apps/app/src/environments/environment';


const uri = environment.graphqlUri;

const APOLLO_CACHE = new InjectionToken<InMemoryCache>('apollo-cache');
const STATE_KEY = makeStateKey<any>('apollo.state');

@NgModule({
  //declarations: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserTransferStateModule,
    ApolloModule,
  ],
  providers: [
      {
        provide: APOLLO_CACHE,
        useValue: new InMemoryCache(),
      },
      {
        provide: APOLLO_OPTIONS,
        useFactory(
          httpLink: HttpLink,
          cache: InMemoryCache,
          transferState: TransferState
              
        ) {
          const isBrowser = transferState.hasKey<any>(STATE_KEY);

          if (isBrowser) {
            const state = transferState.get<any>(STATE_KEY, null);
            cache.restore(state);
          } else {
            transferState.onSerialize(STATE_KEY, () => {
              return cache.extract();
            });
          }

          return {
            link: httpLink.create({uri: uri}),
            cache,
            ...(isBrowser? {ssrForceFetchDelay: 200} : {ssrMode: true}) 
          };
        },
        deps: [HttpLink, APOLLO_CACHE, TransferState],
      },
    ],
})
export class GraphQLModule {}


